import * as React from 'react';
import { cn } from '@/lib/utils';
export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}
const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({
  className,
  onKeyDown,
  ...props
}, ref) => {
  const [isModifierPressed, setIsModifierPressed] = React.useState(false);
  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    // Update modifier key state
    if (e.metaKey || e.ctrlKey) {
      setIsModifierPressed(true);
    }

    // Handle Cmd+Enter (Mac) or Ctrl+Enter (Windows/Linux)
    if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
      e.preventDefault();
      const form = e.currentTarget.form;
      if (form) {
        const submitEvent = new Event('submit', {
          bubbles: true,
          cancelable: true
        });
        form.dispatchEvent(submitEvent);
      }
    }
    // Call the original onKeyDown handler if it exists
    onKeyDown?.(e);
  };
  const handleKeyUp = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    // Reset modifier key state
    if (!e.metaKey && !e.ctrlKey) {
      setIsModifierPressed(false);
    }
  };
  return <textarea className={cn('flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 transition-all duration-200', isModifierPressed && 'ring-2 ring-primary/50', className)} ref={ref} onKeyDown={handleKeyDown} onKeyUp={handleKeyUp} onBlur={() => setIsModifierPressed(false)} {...props} />;
});
Textarea.displayName = 'Textarea';
export { Textarea };